const routeConfig = {
  login: '/login',
  teams: '/teams',
  invitations: '/invitations',
  notification: '/notification',
  notificationDetail: '/notifications/detail',
  checkFile: '/file/:doctype/:category/:id/:name/:page',
  feedbackForm: '/feedback-form',
  dashboard: '/',
  dashboardPersonal: '/personal-dashboard',
  dashboardPersonalAddOn: '/personal-dashboard/add-on',
  dashboardPersonalPco: '/personal-dashboard-pco',
  dashboardPersonalMaximus: '/personal-dashboard-maximus',
  dashboardPersonalHisense: '/personal-dashboard-hisense',
  customer: {
    root: '/customer',
    master: '/customer',
    setting: '/customer/setting',
    analysis: '/customer/analysis',
    create: '/customer/create',
    edit: '/customer/edit/:customerId'
  },
  leads: {
    root: '/leads',
    master: '/leads',
    dashboard: '/leads/dashboard',
    activity: '/leads/activity',
    setting: '/leads/setting',
    import: '/leads/import',
    create: '/leads/create',
    edit: '/leads/edit/:id',
    detail: '/leads/detail/:id',
    detailResult: '/leads/detail/:id/result',
  },
  task: {
    root: '/task',
    master: '/task',
    type: '/task/type',
    monitoring: '/task/monitoring',
    setting: '/task/setting',
    analysis: '/task/analytics',
    calendar: '/task/calendar',
    create: '/task/create',
    edit: '/task/edit/:id',
    monitoringDetailResult: '/task/monitoring/:id/:slug-task',
    revise: '/task/revise/:id'
  },
  ticket: {
    root: '/ticket',
    master: '/ticket',
    detail: '/ticket/:ticketId',
    setting: '/ticket/setting',
  },
  member: {
    root: '/member',
    master: '/member',
    detail: '/member/detail',
    group: '/member/group',
    list: '/member/list',
    setting: '/member/setting',
    feedback: '/member/feedback',
    detailById: '/member/detail/:id',
    edit: '/member/detail/edit/:id',
    privilege: '/member/privilage',
    inviteList: '/member/invite-list',
    journey: '/member-journey',
    journeyDetail: '/member-journey-detail',
  },
  leave: {
    root: '/leave',
    setting: '/leave/setting',
    approval: '/leave/approval',
  },
  attendance: {
    root: '/attendance',
    monitoring: '/attendance/monitoring',
    setting: '/attendance/setting',
  },
  costPerdin: {
    root: '/cost-perdin',
    master: '/cost-perdin',
    create: '/cost-perdin/create',
    detail: '/cost-perdin/:id',
  },
  tracking: {
    root: '/tracking',
    geofence: '/tracking/geofence',
    location: '/tracking/location',
    journey: '/tracking/journey',
    journeyDetail: '/tracking/journey/detail',
  },
  pos: {
    root: '/pos',
    dashboard: '/pos',
    commission: '/pos/commission',
    transaction: '/pos/transaction',
    settlement: '/pos/settlement',
    masterMenu: '/pos/master-menu',
    masterMitra: '/pos/master-mitra',
    masterOutlet: '/pos/master-outlet',
    masterProduct: '/pos/master-product',
  },
  salesOrder: {
    root: '/sales-order',
    product: '/sales-order/product',
    productCreate: '/sales-order/product/create',
    productUpdate: '/sales-order/product/update/:id',
    productBulkUpload: '/sales-order/bulk-upload',
    productBulkUpdate: '/sales-order/bulk-update',
    transaction: '/sales-order/transaction',
    transactionCreate: '/sales-order/create',
    transactionProductDetail: '/sales-order/product-detail',
    transactionCart: '/sales-order/cart',
    transactionCheckout: '/sales-order/checkout',
    transactionUpload: '/sales-order/transaction/upload',
    setting: '/sales-order/setting',
    dashboard: '/sales-order/dashboard',
  },
  team: {
    root: '/team',
    team: '/team',
  },
  bulletin: {
    root: '/bulletin',
    master: '/bulletin',
    create: '/bulletin/create',
    edit: '/bulletin/edit/:id',
  },
  report: '/report',
  configuration: {
    root: '/configuration',
    lookupList: '/configuration/lookup',
  },
  builder: {
    root: '/builder',
    dashboard: '/builder/dashboard',
    report: '/builder/report',
    app: '/builder/app',
    appCreate: '/builder/app/create',
    appEdit: '/builder/app/edit/:id',
    appLookup: '/builder/app/lookup',
    appLookupCreate: '/builder/app/lookup/create',
    appLookupEdit: '/builder/app/lookup/edit/:id',
    appOptionCreate: '/builder/app/option',
    appOptionEdit: '/builder/app/option',
    appOptionFormat: '/builder/app/option/format',
    appOptionPreview: '/builder/app/option/preview',
    reportCreate: '/builder/report/create',
    reportEdit: '/builder/report/edit/:id/:name',
  },
  cashAdvance: {
    root: '/cash-advance',
    master: '/cash-advance',
    transaction: '/cash-advanced/transaction',
  },
  item: {
    root: '/item',
    dashboard: '/item',
    list: '/item/list',
    create: '/item/create',
  },
  invoice: {
    root: '/invoice',
    dashboard: '/invoice',
    master: '/invoice/master',
    create: '/invoice/create',
    detail: '/invoice/:invoiceId',
    setting: '/invoice/setting',
  },
  inventory: {
    root: '/inventory',
    dashboard: '/inventory',
    masterItem: '/inventory/item/master',
    usage: '/inventory/usage',
    stockHistory: '/inventory/stock-history',
    addItem: '/inventory/item/add',
    inventory: '/inventory/inventory',
    masterCategory: '/inventory/category/master',
  },
}

export default routeConfig
